import { Grid, Typography, useMediaQuery } from '@mui/material';
import ClientComponent from '../../components/ClientManagement/ClientComponent';
import ClientsHero from '../../components/ClientManagement/ClientHero';
import React, { useEffect } from 'react';
import UserRole from '../../../shared/AuthRoles';

export default function ClientListPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile ? '100%' : '80%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <Grid
                sx={{
                    width: '100%',
                    height: isMobile ? '2%' : '5%',
                    justifyContent: 'left',
                    display: 'flex',
                }}
            >
                <Typography
                    variant='h1'
                    sx={{
                        textAlign: 'left',
                        textTransform: 'uppercase',
                    }}
                >
                    Manage Hosts
                </Typography>
            </Grid>
            <ClientsHero />
            <Grid
                sx={{
                    width: '100%',
                    minHeight: isMobile ? '65%' : '78%',
                    justifyContent: 'left',
                }}
            >
                <ClientComponent />
            </Grid>
        </Grid>
    );
}
